var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path10, _path11, _path12, _path13, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 78,
    viewBox: "0 0 60 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83811 11.5426C13.6708 9.26552 16.9655 7.91603 23.1137 5.10767L29.6424 8.51257L37.7017 5.29509L52.0711 10.4805C59.1307 14.0104 57.0065 29.1607 58.5997 43.6237C59.5254 52.0267 58.691 57.7059 57.6626 69.426L57.2878 76.0172C54.6033 74.1178 53.0235 74.1789 50.1656 74.8926C51.7586 66.4897 50.7144 61.5409 49.2909 52.7764C49.0578 44.1729 48.956 39.3325 47.3854 31.5035C44.8231 41.6533 44.5067 47.5908 45.0738 58.4304C41.5751 59.305 36.1111 59.5601 29.7049 59.5862C26.3603 59.803 22.7498 59.505 13.3051 58.243C14.1172 47.997 17.772 43.5925 14.1397 32.5031C13.3601 37.0974 12.2741 39.844 11.2433 46.3726C10.9622 56.7435 9.59668 58.7685 8.3382 67.8642C8.80703 70.4542 9.43033 72.1862 10.2126 74.7677C9.33781 73.9867 3.43389 74.2054 2.46563 76.0172L1.74716 68.9262C0.632036 59.9441 1.50836 51.8315 2.68528 40.9361L2.71553 40.6561C4.96464 32.4719 4.83969 16.7593 8.83811 11.5426Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.8363 67.0527C54.8992 67.0268 52.0378 64.3101 51.8379 63.9602L52.0253 64.5537L52.8687 65.3347L54.2432 66.7091L52.4626 66.5217L55.0241 67.0527L57.6481 67.615L55.8363 67.0527Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.88817 59.8369C4.67521 60.214 6.13739 61.3255 6.23099 61.6175C5.17498 60.8824 4.67873 60.6054 4.10683 60.5554C3.54286 60.7362 2.82374 61.5047 2.66831 61.7236C2.6444 61.7708 2.63363 61.7904 2.63866 61.7736C2.6415 61.7642 2.65168 61.7471 2.66831 61.7236C2.80645 61.4513 3.38326 60.2597 3.88817 59.8369Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.88807 46.8423C3.919 46.8853 3.20754 47.4196 3.01342 47.5296C3.24237 47.2865 3.42339 47.1692 3.41951 46.8423C3.23614 46.695 3.14491 46.7808 2.98218 46.9361C3.18125 46.5808 3.29558 46.3866 3.73188 46.405C5.84442 46.8793 6.99384 47.2489 8.94857 48.1543C7.33116 47.6716 3.80306 46.7242 3.88807 46.8423Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6428 6.57593L30.0798 7.20068L30.4546 7.60677L28.6116 9.60599L23.7385 7.63801L24.1134 4.10815L28.6428 6.57593Z",
    fill: "white",
    stroke: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0487 6.63782C26.4456 4.82046 24.0507 2.6394 24.2381 1.38989C23.6766 3.19706 23.396 4.22817 22.6138 5.91936C22.9533 7.36869 23.3827 8.39874 24.488 10.5425C26.0244 8.32492 27.007 7.43187 29.0487 6.63782Z",
    fill: "white",
    stroke: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6114 9.69932C28.3078 8.34274 28.6842 7.65369 30.9854 6.63803L37.4204 4.38892L36.2646 7.20031C33.3488 8.97104 31.552 9.77143 28.6114 9.69932Z",
    fill: "white",
    stroke: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6087 10.5117C33.1113 7.66187 31.9256 6.50215 30.9231 6.70068C33.7657 4.4828 37.0457 3.32701 36.4522 1.10913C37.1357 2.8852 37.4795 3.94557 37.9516 6.07592C37.3611 7.82441 36.7338 8.78991 35.6087 10.5117Z",
    fill: "white",
    stroke: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7362 59.6797C27.7679 44.3732 29.5173 32.0031 28.5176 9.54321",
    stroke: "#333333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65061 68.2076C5.69618 67.3767 4.1502 67.4074 1.77832 69.176C1.99698 71.4563 2.45679 76.1659 2.46555 76.1107C2.66283 74.8681 7.74472 73.7054 10.2125 74.7675C9.48855 72.2701 9.11423 70.8695 8.65061 68.2076Z",
    fill: "white",
    stroke: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4154 69.3949C53.2569 67.5501 54.8437 67.4696 57.6313 69.2075L57.2877 76.0485C54.8503 74.3685 53.2975 73.9719 50.0718 74.9239C50.3567 72.9796 50.439 71.723 50.4154 69.3949Z",
    fill: "white",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 29.8924,
    cy: 8.48127,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 30.2984,
    cy: 14.6663,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 30.3609,
    cy: 22.4129,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 30.5482,
    cy: 31.6595,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 30.7982,
    cy: 40.8436,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 30.5482,
    cy: 50.2147,
    r: 0.437327,
    fill: "#333333",
    stroke: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.8828 43.5298C52.9561 44.5502 51.034 46.691 50.7591 47.0909C50.6255 47.3581 50.3935 47.8475 50.2622 48.197C50.1975 48.4662 50.1567 48.6166 50.1655 48.5278C50.1727 48.456 50.2093 48.3379 50.2622 48.197C50.3796 47.7086 50.5758 46.8292 50.6966 46.2787L53.3206 43.3111L49.6033 42.3115L55.4135 43.1237L53.8828 43.5298Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.4159 26.0993C49.2989 27.28 48.2954 30.7727 48.0414 31.5972C48.3466 29.2738 48.439 28.0172 48.0414 26.0993C47.6008 25.2348 47.4348 24.728 47.2605 23.7877L47.2711 23.7973C47.6723 24.1582 47.9006 24.3636 48.6662 24.35C50.2827 21.005 50.8054 19.0346 51.6962 15.5098C51.0061 18.9671 50.6387 20.9061 49.4159 24.35C50.5861 23.5631 51.238 22.9875 52.3835 21.5699C51.3004 23.5196 50.6386 24.4839 49.4159 26.0993Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.86929 43.905C9.56387 44.3913 10.3211 44.8498 11.2746 45.1233L10.931 44.8734L10.5874 44.6235L10.1188 44.0612C10.4943 43.8834 10.8231 43.902 11.2746 43.905C10.5065 43.6955 9.98251 43.713 9.08796 43.6864C7.0784 42.7909 6.12052 42.0071 4.30859 40.7812C5.94929 42.175 6.89372 42.9252 8.86929 43.905Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6174 28.5981C13.9431 29.3337 14.3242 31.4809 14.2109 31.9718L14.3046 32.2529C14.4251 30.8257 14.3815 30.0255 14.2109 28.5981L13.9922 28.1295L13.3987 26.4739C12.9203 25.0204 12.6719 24.0644 12.2429 22.2568C12.4512 23.3085 12.7427 24.9745 12.8677 25.4743C12.9761 25.9082 13.2113 26.7551 13.5861 27.9733C12.5384 26.8098 11.9148 26.2576 10.9622 24.912C11.561 25.9636 11.9275 26.5807 13.6174 28.5981Z",
    fill: "#333333",
    stroke: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0861 31.8051L12.7326 31.4516L12.379 31.8051L11.5683 32.6159L11.2151 32.9691L11.568 33.3227L13.9247 35.6836H8.13265H7.63265V36.1836V37.3336V37.8336H8.13265H13.9217L11.5629 40.1882L11.2087 40.5418L11.5625 40.8956L12.379 41.7121L12.7326 42.0657L13.0861 41.7121L17.6861 37.1122L18.0396 36.7586L17.6861 36.4051L13.0861 31.8051Z",
    fill: "#333333",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_625_4297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7288 41.712L46.0824 42.0655L46.4359 41.712L47.2466 40.9012L47.5999 40.548L47.247 40.1944L44.8902 37.8335H50.6823H51.1823V37.3335V36.1835V35.6835H50.6823H44.8933L47.2521 33.3289L47.6063 32.9753L47.2524 32.6215L46.4359 31.805L46.0824 31.4514L45.7288 31.805L41.1289 36.4049L40.7753 36.7585L41.1289 37.112L45.7288 41.712Z",
    fill: "#333333",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7998,
    height: 13.7998,
    fill: "white",
    transform: "matrix(0 1 -1 0 19.6326 29.8586)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_625_4297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7998,
    height: 13.7998,
    fill: "white",
    transform: "matrix(0 -1 1 0 39.1824 43.6584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFit);
export default __webpack_public_path__ + "static/media/fit.a28b4dff0a83e71651016389dd14eeb5.svg";
export { ForwardRef as ReactComponent };